module.exports = __webpack_public_path__ + "img/20_66.6f745f96.png";